// import { CoherenceDataGridColumn } from '@coherence-design-system/controls';
import { INodeExpression, ISignalSource, RuleApprovalStatus, RulesDropdownItem, RuleType } from '../common/Types';
import { v4 as uuidv4 } from 'uuid';

import {
  IAction, IRule, ISecurityPool, IAlertOnboard
} from './Types';

import { Stack, IconButton, IColumn, IContextualMenuItem } from '@fluentui/react';
import { IAccountInfo } from 'react-aad-msal';
import React from 'react';

export const AlertPipelineCrudListColumns = {

  getSignalSourceColumns: function (
    onViewItem?: (item: ISignalSource) => void,
    onEditItem?: (item: ISignalSource) => void,
    onViewSecurity?: (item: ISignalSource) => void,
    onViewRules?: (item: ISignalSource) => void,
    onViewActions?: (item: ISignalSource) => void,
    onViewAlertOnboard?: (item: ISignalSource) => void): IColumn[] {

    const menuActions: IContextualMenuItem[] = [];
    if (onViewItem) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onViewItem(item as unknown as ISignalSource);
        },
        key: 'view',
        text: 'View',
        iconProps: { iconName: 'View' }
      });
    }

    if (onEditItem) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onEditItem(item as unknown as ISignalSource);
        },
        key: 'edit',
        text: 'Edit',
        iconProps: { iconName: 'Edit' }
      });
    }

    if (onViewSecurity) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onViewSecurity(item as unknown as ISignalSource);
        },
        key: 'security',
        text: 'Security',
        iconProps: { iconName: 'SecurityGroup' }
      });
    }

    if (onViewRules) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onViewRules(item as unknown as ISignalSource);
        },
        key: 'rules',
        text: 'Rules',
        iconProps: { iconName: 'Code' }
      });
    }

    if (onViewActions) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onViewActions(item as unknown as ISignalSource);
        },
        key: 'actions',
        text: 'Actions',
        iconProps: { iconName: 'SetAction' }
      });
    }

    if (onViewAlertOnboard) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onViewAlertOnboard(item as unknown as ISignalSource);
        },
        key: 'alertonboard',
        text: 'Alert Onboard',
        iconProps: { iconName: 'Code' }
      });
    }

    return [
      {
        key: 'id',
        name: 'ID',
        fieldName: 'shortName',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'name',
        name: 'Name',
        fieldName: 'name',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'isActive',
        name: 'Active',
        fieldName: 'enabled',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'modifiedOn',
        name: 'Modified On',
        fieldName: 'modifiedOn',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'actions',
        name: 'Actions',
        minWidth: 50,
        maxWidth: 50,
        isResizable: false,
        onRender: (item) => (
        <IconButton
          iconProps={{ iconName: 'MoreVertical' }}
          menuProps={{
            items: menuActions.map((action) => ({
              ...action,
              data: item
            }))
          }}
        />
        )
      }
    ];
  },

  getActionColumns: function (
    onViewItem?: (item: IAction) => void,
    onEditItem?: (item: IAction) => void,
    onDeleteItem?: (item: IAction) => void): IColumn[] {

    const menuActions = [];
    if (onViewItem) {
      menuActions.push({
        onClick: (item: IAction) => {
          onViewItem(item);
        },
        key: 'view',
        text: 'View',
        iconProps: { iconName: 'View' }
      });
    }

    if (onEditItem) {
      menuActions.push({
        onClick: (item: IAction) => {
          onEditItem(item);
        },
        key: 'edit',
        text: 'Edit',
        iconProps: { iconName: 'Edit' }
      });
    }

    if (onDeleteItem) {
      menuActions.push({
        onClick: (item: IAction) => {
          onDeleteItem(item);
        },
        key: 'delete',
        text: 'Delete',
        iconProps: { iconName: 'Delete' }
      });
    }

    return [
      {
        key: 'id',
        name: 'ID',
        fieldName: 'shortName',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'name',
        name: 'Name',
        fieldName: 'name',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'isActive',
        name: 'Active',
        fieldName: 'enabled',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'actionType',
        name: 'Type',
        fieldName: 'actionType',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      }
    ];
  },

  getRuleColumns: function (
    accountInfo?: IAccountInfo,
    onViewItem?: (item: IRule) => void,
    onEditItem?: (item: IRule) => void,
    onDeleteItem?: (item: IRule) => void,
    onApproveItem?: (item: IRule) => void,
    onRejectItem?: (item: IRule) => void): IColumn[] {

    const menuActions: IContextualMenuItem[] = [];

    if (onViewItem) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onViewItem(item as unknown as IRule);
        },
        key: 'view',
        text: 'View',
        iconProps: { iconName: 'View' }
      });
    }

    if (onEditItem) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onEditItem(item as unknown as IRule);
        },
        key: 'edit',
        text: 'Edit',
        iconProps: { iconName: 'Edit' }
      });
    }

    if (onDeleteItem) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onDeleteItem(item as unknown as IRule);
        },
        key: 'delete',
        text: 'Delete',
        iconProps: { iconName: 'Delete' }
      });
    }

    return [
      {
        key: 'id',
        name: 'ID',
        fieldName: 'shortName',
        minWidth: 100,
        maxWidth: 150,
        isResizable: true
      },
      {
        key: 'name',
        name: 'Name',
        fieldName: 'name',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'isActive',
        name: 'Active',
        fieldName: 'isActive',
        minWidth: 50,
        maxWidth: 80,
        isResizable: true
      },
      {
        key: 'priority',
        name: 'Priority',
        fieldName: 'priority',
        minWidth: 50,
        maxWidth: 80,
        isResizable: true
      },
      {
        key: 'ruleType',
        name: 'Type',
        fieldName: 'ruleType',
        minWidth: 160,
        maxWidth: 180,
        isResizable: true
      },
      {
        key: 'modifiedOn',
        name: 'Modified On',
        fieldName: 'modifiedOn',
        minWidth: 130,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'approvalStatus',
        name: 'Approval Status',
        minWidth: 120,
        maxWidth: 150,
        isResizable: true,
        fieldName: 'approvalStatus'
      },
      {
        key: 'approve',
        name: 'Approve/Reject',
        isResizable: true,
        minWidth: 100,
        maxWidth: 200,
        onRender: (item: IRule) => {
          if (
            (item.ruleType === RuleType.IcmRouting || item.ruleType === RuleType.Suppression) &&
            item.approvalStatus === RuleApprovalStatus.PendingApproval &&
            accountInfo &&
            item.createdBy !== accountInfo?.account.accountIdentifier &&
            item.teamAdminContact?.includes(accountInfo.account.userName)
          ) {
            // Rendering Approve/Reject buttons
            return <Stack tokens={ { childrenGap: 8 } } horizontal>
              <IconButton iconProps={ { iconName: 'Accept' } } styles={ { icon: { color: 'green' } } }
                title="Approve" ariaLabel="Approve"
                onClick={ () => onApproveItem ? onApproveItem(item) : {} } />
              <IconButton
                iconProps={ { iconName: 'clear', color: 'red' } } styles={ { icon: { color: 'red' } } } title="Reject"
                ariaLabel="Reject" onClick={ () => onRejectItem ? onRejectItem(item) : {} } />
            </Stack>;
          } else {
            return <span></span>;
          }
        }
      },
      {
        key: 'actions',
        name: 'Actions',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onRender: (item) => (
              <IconButton
                  iconProps={{ iconName: 'MoreVertical' }}
                  menuProps={{
                    items: menuActions.map((action) => ({
                      ...action,
                      data: item
                    }))
                  }}
              />
        )
      }
    ];
  },

  getSecurityPoolColumns: function (
    onViewItem?: (item: ISecurityPool) => void,
    onEditItem?: (item: ISecurityPool) => void): IColumn[] {
    const menuActions: IContextualMenuItem[] = [];
    if (onViewItem) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onViewItem(item as unknown as ISecurityPool);
        },
        key: 'view',
        text: 'View',
        iconProps: { iconName: 'View' }
      });
    }

    if (onEditItem) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onEditItem(item as unknown as ISecurityPool);
        },
        key: 'edit',
        text: 'Edit',
        iconProps: { iconName: 'Edit' }
      });
    }

    return [
      {
        key: 'id',
        name: 'ID',
        fieldName: 'shortName',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'name',
        name: 'Name',
        fieldName: 'name',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'modifiedOn',
        name: 'Modified On',
        fieldName: 'modifiedOn',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      }
    ];
  },

  getAlertOnboardColumns: function (
    accountInfo?: IAccountInfo,
    onViewItem?: (item: IAlertOnboard) => void,
    onEditItem?: (item: IAlertOnboard) => void,
    onDeleteItem?: (item: IAlertOnboard) => void): IColumn[] {

    const menuActions: IContextualMenuItem[] = [];

    if (onViewItem) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onViewItem(item as unknown as IAlertOnboard);
        },
        key: 'view',
        text: 'View',
        iconProps: { iconName: 'View' }
      });
    }

    if (onEditItem) {
      menuActions.push({
        onClick: (_, item) => {
          if (item) onEditItem(item as unknown as IAlertOnboard);
        },
        key: 'edit',
        text: 'Edit',
        iconProps: { iconName: 'Edit' }
      });
    }

    return [
      {
        key: 'serviceLineName',
        name: 'ServiceLine',
        fieldName: 'serviceLineName',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'scenarioName',
        name: 'ScenarioName',
        fieldName: 'scenarioName',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'isActive',
        name: 'Status',
        fieldName: 'isActive',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'createdBy',
        name: 'Created By',
        fieldName: 'createdBy',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
      },
      {
        key: 'createdOn',
        name: 'Created On',
        fieldName: 'createdOn',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        isSorted: true
      },
      {
        key: 'modifiedBy',
        name: 'Modified By',
        fieldName: 'modifiedBy',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        isSorted: true
      },
      {
        key: 'modifiedOn',
        name: 'Modified On',
        fieldName: 'modifiedOn',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        isSorted: true
      },
      {
        key: 'actions',
        name: 'Actions',
        isResizable: false,
        maxWidth: 50,
        minWidth: 50,
        onRender: (item) => (
        <IconButton
          iconProps={{ iconName: 'MoreVertical' }}
          menuProps={{
            items: menuActions.map((action) => ({
              ...action,
              data: item
            }))
          }}
        />
        )
      }
    ];
  }
};

export const RuleExpressions = {

  getDefaultRule: function (): any {
    return {
      key: uuidv4(),
      Operator: 'eqignorecase',
      Operands: [{
        key: uuidv4(),
        OperandType: 'string'
      }, {
        key: uuidv4(),
        OperandType: 'string'
      }]
    } as INodeExpression;
  },

  deepReplaceObject: function (source: any, filterPropName: string, filterPropValue: string, propObjectToChange: any): any {
    if (source instanceof Array) {
      const clonedObject = [];
      for (let i = 0; i < source.length; i++) {
        const instance = RuleExpressions.deepReplaceObject(source[i], filterPropName, filterPropValue, propObjectToChange);
        clonedObject.push(instance);
      }

      return clonedObject;
    } else {
      if (source[filterPropName] && source[filterPropName].toString() === filterPropValue) {
        return propObjectToChange;
      } else {
        const clonedObject = {} as any;
        for (const prop in source) {
          if (source[prop] instanceof Object || source[prop] instanceof Array) {
            const instance = RuleExpressions.deepReplaceObject(source[prop], filterPropName, filterPropValue, propObjectToChange);
            clonedObject[prop] = instance;
          } else {
            clonedObject[prop] = source[prop];
          }
        }

        return clonedObject;
      }
    }
  },

  deepReplaceProperty: function (source: any, filterPropName: string, filterPropValue: string,
    propNameToChange: string, propValueToChange: any): any {
    if (source instanceof Array) {
      const clonedObject = [];
      for (let i = 0; i < source.length; i++) {
        const instance = RuleExpressions.deepReplaceProperty(source[i], filterPropName, filterPropValue,
          propNameToChange, propValueToChange);
        clonedObject.push(instance);
      }

      return clonedObject;
    } else {
      const clonedObject = {} as any;
      let changed = false;
      for (const prop in source) {
        if (prop === filterPropName && source[prop].toString() === filterPropValue) {
          clonedObject[prop] = source[prop];
          clonedObject[propNameToChange] = propValueToChange;
          changed = true;
        } else {
          if (!changed || (changed && prop !== propNameToChange)) {
            if (source[prop] instanceof Object || source[prop] instanceof Array) {
              const instance = RuleExpressions.deepReplaceProperty(source[prop], filterPropName, filterPropValue,
                propNameToChange, propValueToChange);
              clonedObject[prop] = instance;
            } else {
              clonedObject[prop] = source[prop];
            }
          }
        }
      }

      return clonedObject;
    }
  },

  deepDelete: function (source: any, propName: string, propValue: string): any {
    if (source instanceof Array) {
      const clonedObject = [];
      for (let i = 0; i < source.length; i++) {
        const instance = RuleExpressions.deepDelete(source[i], propName, propValue);
        if (instance) {
          clonedObject.push(instance);
        }
      }

      return clonedObject;
    } else {
      const clonedObject = {} as any;
      for (const prop in source) {
        if (prop === propName && source[prop].toString() === propValue) {
          return undefined;
        } else {
          if (source[prop] instanceof Object || source[prop] instanceof Array) {
            const instance = RuleExpressions.deepDelete(source[prop], propName, propValue);
            if (instance) {
              clonedObject[prop] = instance;
            }
          } else {
            clonedObject[prop] = source[prop];
          }
        }
      }

      return clonedObject;
    }
  },

  generateKeys: function (source: any): any {
    if (source instanceof Array) {
      const clonedObject = [];
      for (let i = 0; i < source.length; i++) {
        const instance = RuleExpressions.generateKeys(source[i]);
        clonedObject.push(instance);
      }

      return clonedObject;
    } else if (source instanceof Object) {
      const clonedObject = {} as any;
      clonedObject.key = uuidv4();
      for (const prop in source) {
        clonedObject[prop] = RuleExpressions.generateKeys(source[prop]);
      }

      return clonedObject;
    } else {
      return source;
    }
  },

  stripKeys: function (source: any): any {
    if (source instanceof Array) {
      const clonedObject = [];
      for (let i = 0; i < source.length; i++) {
        const instance = RuleExpressions.stripKeys(source[i]);
        clonedObject.push(instance);
      }

      return clonedObject;
    } else if (source instanceof Object) {
      const clonedObject = {} as any;
      for (const prop in source) {
        if (prop !== 'key') {
          clonedObject[prop] = RuleExpressions.stripKeys(source[prop]);
        }
      }

      return clonedObject;
    } else {
      return source;
    }
  },

  isExpressionValid: function (source: any): boolean {
    if (source instanceof Array) {
      let isValid = true;
      for (let i = 0; i < source.length; i++) {
        isValid = isValid && RuleExpressions.isExpressionValid(source[i]);
      }

      return isValid;
    } else if (source instanceof Object) {
      if ('OperandType' in source) {
        if (('JsonPath' in source && source.JsonPath) || ('Value' in source && source.Value)) {
          let isValid = true;
          for (const prop in source) {
            isValid = isValid && RuleExpressions.isExpressionValid(source[prop]);
          }

          return isValid;
        } else {
          return false;
        }
      } else {
        let isValid = true;
        for (const prop in source) {
          isValid = isValid && RuleExpressions.isExpressionValid(source[prop]);
        }

        return isValid;
      }
    } else {
      return true;
    }
  }
};

export const JsonSchema = {

  flattenSchema (jsonSchemaString: string, rootProperty: string | null, rootPath: string): RulesDropdownItem[] {

    const getAlpType = (schemaType: string): string => {
      if (schemaType.toLowerCase() === 'string') {
        return 'string';
      } else if (schemaType.toLowerCase() === 'integer') {
        return 'int';
      } else if (schemaType.toLowerCase() === 'number') {
        return 'double';
      } else if (schemaType.toLowerCase() === 'boolean') {
        return 'bool';
      } else {
        return 'string';
      }
    };

    const convertToFlatList = (rootObjectPath: string, prefix: string, rootSchemaObject: any): RulesDropdownItem[] => {
      const splitRefs = rootObjectPath.split('/');
      let schemaObj = {} as any;
      splitRefs.forEach(ref => {
        if (ref === '#') {
          schemaObj = rootSchemaObject;
        } else {
          schemaObj = schemaObj[ref];
        }
      });

      const allRefProperties = schemaObj.properties;
      const finalList = [] as RulesDropdownItem[];
      const allKeys = Object.keys(allRefProperties);
      allKeys.forEach(key => {
        if (allRefProperties[key].type && !allRefProperties[key].hidden) {
          if (allRefProperties[key].type.toString().toLowerCase() === 'string' ||
            allRefProperties[key].type.toString().toLowerCase() === 'integer' ||
            allRefProperties[key].type.toString().toLowerCase() === 'number' ||
            allRefProperties[key].type.toString().toLowerCase() === 'boolean') {
            finalList.push({
              displayName: allRefProperties[key].displayName ? allRefProperties[key].displayName : (prefix ? prefix + '.' : '') + key,
              jsonPath: '$.' + (prefix ? prefix + '.' : '') + key,
              type: getAlpType(allRefProperties[key].type.toString())
            });
          } else if (allRefProperties[key].type.toString().toLowerCase() === 'array') {
            finalList.push({
              displayName: allRefProperties[key].displayName ? allRefProperties[key].displayName : (prefix ? prefix + '.' : '') + key,
              jsonPath: '$.' + (prefix ? prefix + '.' : '') + key,
              type: 'collection'
            });
          } else {
            finalList.push({
              displayName: allRefProperties[key].displayName ? allRefProperties[key].displayName : (prefix ? prefix + '.' : '') + key,
              jsonPath: '$.' + (prefix ? prefix + '.' : '') + key,
              type: getAlpType(allRefProperties[key].type.toString())
            });
          }
        } else if (allRefProperties[key].$ref) {
          const refKeys = convertToFlatList(allRefProperties[key].$ref.toString(), (prefix ? prefix + '.' : '') + key, rootSchemaObject);
          finalList.push(...refKeys);
        }
      });

      return finalList;
    };

    const convertToFlatListDeep = (rootPath: string, propertyPath: string, rootSchemaObject: any): any => {
      if (rootPath !== null && rootPath !== '$') {
        const allRootNests = rootPath.split('.');
        let currentPropertyChildren = {} as any;
        allRootNests.forEach(currentRoot => {
          if (currentRoot === '$') {
            currentPropertyChildren = rootSchemaObject.properties;
          } else {
            let refString = '';
            if (currentPropertyChildren[currentRoot] && currentPropertyChildren[currentRoot].$ref) {
              refString = currentPropertyChildren[currentRoot].$ref;
            } else if (currentPropertyChildren[currentRoot] &&
              currentPropertyChildren[currentRoot].type?.toString().toLowerCase() === 'array') {
              refString = currentPropertyChildren[currentRoot].items.$ref;
            }

            const splitRefs = (refString).split('/');
            splitRefs.forEach(ref => {
              if (ref === '#') {
                currentPropertyChildren = rootSchemaObject;
              } else {
                currentPropertyChildren = currentPropertyChildren[ref];
              }
            });

            currentPropertyChildren = currentPropertyChildren.properties;
          }
        });

        rootSchemaObject.properties = currentPropertyChildren;
      }

      const allNests = propertyPath.split('.');
      let currentPropertyChildren = {} as any;
      let finalList = [] as any[];
      allNests.forEach(currentProperty => {
        if (currentProperty === '$') {
          currentPropertyChildren = rootSchemaObject.properties;
        } else {
          let refString = '';
          if (currentPropertyChildren[currentProperty] && currentPropertyChildren[currentProperty].$ref) {
            refString = currentPropertyChildren[currentProperty].$ref;
          } else if (currentPropertyChildren[currentProperty] &&
            currentPropertyChildren[currentProperty].type?.toString().toLowerCase() === 'array') {
            refString = currentPropertyChildren[currentProperty].items.$ref;
          }

          finalList = convertToFlatList(refString, '', rootSchemaObject);
          const splitRefs = (refString).split('/');
          splitRefs.forEach(ref => {
            if (ref === '#') {
              currentPropertyChildren = rootSchemaObject;
            } else {
              currentPropertyChildren = currentPropertyChildren[ref];
            }
          });

          currentPropertyChildren = currentPropertyChildren.properties;
        }
      });

      return finalList;
    };

    const finalList = [] as RulesDropdownItem[];

    try {
      if (jsonSchemaString) {
        const rootSchemaObject = JSON.parse(jsonSchemaString);

        if (!rootProperty) {
          const refKeys = convertToFlatList('#', '', rootSchemaObject);
          finalList.push(...refKeys);
        } else {
          const refKeys = convertToFlatListDeep(rootPath, rootProperty, rootSchemaObject);
          finalList.push(...refKeys);
        }
      }
    } catch (error) {
      console.log(error);
    }

    finalList.sort((a, b) => (a.displayName > b.displayName) ? 1 : ((b.displayName > a.displayName) ? -1 : 0));
    return finalList;
  }
};
